
import store from '@/store';
import Vue from 'vue'
import { EmailSend } from '@chainsight/networker-backend-axios-sdk';
import { format } from 'date-fns';
import { Viewer } from '@toast-ui/vue-editor';

type EmailSendWithExpanded = EmailSend & { expanded: boolean }

export default Vue.extend({
	name: 'BusinessMatchEmailSent',
	components: {
		viewer: Viewer
		// editor: Editor,
		// TimeCollection
	},
	data() {
		return {
			overlay: false,
			emailSearchText: '',
			emailSendList: [] as EmailSendWithExpanded[],
			emailSendFilteredList: [] as EmailSendWithExpanded[],
		};
	},
	computed: {
		trackDto(){
			return store.state.track.trackDto
		},
		user() {
			return store.state.user;
		},
		// filteredEmailSendList(){
		// 	return this.emailSendList.filter((e: any) => {
		// 		if(!this.emailSearchText) return true
		// 		return ((e.title ?? e.subject ?? '').toString().toLowerCase()).includes(this.emailSearchText.toLowerCase())
		// 	})
		// }
	},
	methods: {
		emailFilter() {
			const searchLower = this.emailSearchText.toLowerCase();
			this.emailSendFilteredList = this.emailSendList.filter(item => 
				item.title?.toLowerCase().includes(searchLower)
			);
		},
		filterEmailSendList() {
			this.emailSendFilteredList = this.emailSendList.filter((e: EmailSendWithExpanded) => {
				if (!this.emailSearchText) return true
				return (
					( e.title ?? '')
						.toString()
						.toLowerCase())
						.includes(this.emailSearchText.toLowerCase()
				)
			})
		},
		async getEmails(){
			try {
				const resp = await this.api$.userApi.getEmailSends(0, 50)
				this.emailSendList = (resp.data.data as EmailSend[])
					.map(email => ({
						...email,
						createdAt: format(new Date(email.createdAt as string), "MMM d, yyyy 'at' h:mm a"),
						expanded: false
					})) as EmailSendWithExpanded[]

					this.emailSendFilteredList = JSON.parse(JSON.stringify(this.emailSendList))
			} catch (e) {
				console.log(e)
			}
		}
	},
	async created(){
		this.overlay = true
		await this.getEmails()
		this.overlay = false
	},
	watch: {
		'$i18n.locale': {
			immediate: false,
			async handler() {
				this.overlay = true
				await this.getEmails()
				this.overlay = false
			}
		}
	}
});
